/**
 * Created by mac on 5/25/21
 */

const HeroTutorial = function (unit) {
    UnitComponent.call(this, unit);

    this.stage = 0;
    this.isTutorialRunning = true;
    this.isHidden = true;

    this.unit.movable = false;
    this.animate = true;
};

HeroTutorial.prototype = Object.create(UnitComponent.prototype);
HeroTutorial.prototype.constructor = HeroTutorial;

HeroTutorial.prototype.start = function (callback) {
    cleverapps.focusManager.display({
        stack: true,
        focus: "customMergeTutorial",
        action: function (f) {
            this.finishTutorialStepHandler = Map2dLocation.currentLocation.tutorial.on("finishTutorialStep", () => {
                this.stage++;
                this.animate = true;
            });

            this.view.waveAnimation();

            cleverapps.timeouts.setTimeout(() => {
                Map2dLocation.currentLocation.tutorial.showTutorial(Map2dLocation.currentLocation.getMergeTutorial("dwarf_hustlemerge"), () => {
                    cleverapps.timeouts.setTimeout(() => {
                        f();
                        callback();

                        this.finish();
                    }, 1000);
                });
            }, 2000);
        }.bind(this)
    });
};

HeroTutorial.prototype.handleClick = function () {
    if (!this.animate) {
        return false;
    }

    if (this.stage < HeroTutorial.TOTAL_STAGES) {
        if (this.stage < HeroTutorial.REMOVE_DEBRIS_STAGES) {
            this.view.animateRemoveDebris();
        }

        this.view.animateResuscitation();
        this.animate = false;
    }

    return true;
};

HeroTutorial.prototype.finish = function () {
    this.isTutorialRunning = false;
    this.unit.movable = true;
    this.finishTutorialStepHandler.clear();
};

HeroTutorial.FINISH_ANIMATION_DURATION = 1000;
HeroTutorial.REMOVE_DEBRIS_STAGES = 3;
HeroTutorial.TOTAL_STAGES = 4;